var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "file-upload-button"
  }, [_c('input', {
    ref: "fileInput",
    staticClass: "file-upload-button__input",
    attrs: {
      "accept": _vm.acceptedExtnames,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple,
      "type": "file"
    },
    on: {
      "change": _vm.onSelect
    }
  }), _vm._v(" "), _c('common-button', {
    attrs: {
      "disabled": _vm.disabledOrUploading,
      "size": _vm.size,
      "text": _vm.text,
      "type": _vm.type,
      "icon": "cloud-upload"
    },
    on: {
      "click": function($event) {
        _vm.$refs.fileInput.click()
      }
    }
  }, [_vm._t("default", [(_vm.text) ? _c('span', [_vm._v(_vm._s(_vm.text))]) : _c('span', [_vm._v(_vm._s(_vm.$t('actions.upload')))])])], 2)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec47cac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/FileUploadButton.vue
// module id = 1854
// module chunks = 0